// extracted by mini-css-extract-plugin
export default {"tabs":"styles__tabs___uBm2O","list":"styles__list___VrB51","tab":"styles__tab___NkC4j","focus-visible":"styles__focus-visible___n4sK7","disabled":"styles__disabled___xnk8R"};